@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.drivergrouptargets
import com.narbase.letsgo.dto.core.KmmLong

class DriverGroupTargetDto (
    val id: KmmLong? = null,
    val groupId: KmmLong,
    val targetId: KmmLong,
)